import { Component, OnInit } from "@angular/core";
import { LoaderService } from "./shared/loading/loader.service";
import { AuthService } from "./auth/auth.service";

export const LANG = "lang";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  userName: string | null = null;
  userEmail: string | null = null;

  constructor(
    public loading: LoaderService,
    public auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.auth.user$.subscribe((user) => {
      if (user) {
        this.userName = user.displayName || "";
        this.userEmail = user.email || "";
      }
    });
  }
}
